import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "common",
  initialState: {
    firstTime: false,
    codesList: [],
  },
  reducers: {
    setFirstTime: (state, action) => {
      return {
        ...state,
        firstTime: action.payload,
      };
    },
    setCodesList: (state, action) => {
      return {
        ...state,
        codesList: action.payload,
      };
    },
  },
});

export default slice.reducer;

export const { setFirstTime, setCodesList } = slice.actions;

export const setCodesListInformation = (data) => async (dispatch) => {
  dispatch(setCodesList(data));
};
